import { render, staticRenderFns } from "./WorkshopsTable.vue?vue&type=template&id=027caec5&"
import script from "./WorkshopsTable.vue?vue&type=script&lang=js&"
export * from "./WorkshopsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports